var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process-overview-values-table-cell" }, [
    _c(
      "span",
      { staticClass: "process-overview-values-table-cell__legend" },
      [
        _c("legend-item", {
          attrs: {
            "status-color": _vm.historyStatusColor,
            "status-label": _vm.$t("historyShort"),
            clickable: _vm.isHistoryClickable,
          },
          on: {
            legendClicked: function ($event) {
              _vm.isHistoryClickable &&
                _vm.handleLegendClicked(_vm.OVERVIEW_VALUE_TYPE_HISTORIC)
            },
          },
        }),
        _c("div", {
          staticClass: "process-overview-values-table-cell__legend__separator",
        }),
        _c("legend-item", {
          attrs: {
            "status-color": _vm.currentStatusColor,
            "status-label": _vm.$t("currentShort"),
            clickable: _vm.isCurrentClickable,
          },
          on: {
            legendClicked: function ($event) {
              _vm.isCurrentClickable &&
                _vm.handleLegendClicked(_vm.OVERVIEW_VALUE_TYPE_CURRENT)
            },
          },
        }),
      ],
      1
    ),
    _vm.date
      ? _c(
          "span",
          { staticClass: "process-overview-values-table-cell__date" },
          [
            _c("span", [
              _vm._v(
                " " + _vm._s(_vm._f("puiFormatDateShort")(_vm.date)) + " "
              ),
            ]),
            _c("span", [
              _vm._v(
                " " + _vm._s(_vm._f("puiFormatTimeMedium")(_vm.date)) + " "
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }